import "../styles/utils/Botao.css"
function Botao({ children, handleOnClick, estilo }) {
    return (
        <div className="botao-container" onClick={handleOnClick} style={estilo}>
            <span>{children}</span>            
        </div>
    )
}

export default Botao
